
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/dhi-portals",
      function () {
        return require("private-next-pages/archive/dhi-portals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/dhi-portals"])
      });
    }
  